import HomeIcon from "@mixitone/icons/club.svg";
import SignOutIcon from "@mixitone/icons/signout.svg";
import TrophyIcon from "@mixitone/icons/trophy.svg";
import UserIcon from "@mixitone/icons/user.svg";
import { ApplicationView } from "@mixitone/mvc";
import { AuthController } from "controllers/AuthController";
import { NavLink } from "react-router-dom";

const navClassName =
  "[&.active]:text-white [&.active]:stroke-white [&.active]:fill-white flex flex-col items-center text-xs hover:stroke-white hover:text-white hover:fill-white";

const Menu = () => {
  const controller = AuthController.use();

  return (
    <div className="fixed top-2 flex w-full max-w-md items-center justify-end gap-2 px-2 *:fill-slate-300 *:stroke-slate-300 *:text-slate-300">
      <NavLink to="/in/home" className={navClassName}>
        <HomeIcon className="h-6 w-5" />
        <span>Clubs</span>
      </NavLink>
      <NavLink to="/in/tournaments" className={navClassName}>
        <TrophyIcon className="h-6 w-5" />
        <span>Tournaments</span>
      </NavLink>
      <NavLink to="/in/profile" className={navClassName}>
        <UserIcon className="h-6 w-6" />
        <span>Profile</span>
      </NavLink>
      <button onClick={() => controller.actionLogOut()} className={navClassName}>
        <SignOutIcon className="h-6 w-6" />
        <span>Sign out</span>
      </button>
    </div>
  );
};

export default ApplicationView(Menu);
